"use strict";

import { dataUploadConstants } from "../_constants";

export const dataUploadDataTemplateListRequest = (payload) => {
     return {
          type: dataUploadConstants.DATA_UPLOAD_DATA_TEMPLATE_LIST_REQUEST,
          payload,
     };
};

export const dataUploadDataTemplateListComplete = (payload) => {
     return {
          type: dataUploadConstants.DATA_UPLOAD_DATA_TEMPLATE_LIST_COMPLETE,
          payload,
     };
};

export const dataUploadListRequest = (payload) => {
     return {
          type: dataUploadConstants.DATA_UPLOAD_LIST_REQUEST,
          payload,
     };
};

export const dataUploadListComplete = (payload) => {
     return {
          type: dataUploadConstants.DATA_UPLOAD_LIST_COMPLETE,
          payload,
     };
};

export const dataUploadSilentListRequest = (payload) => {
     return {
          type: dataUploadConstants.DATA_UPLOAD_LIST_SILENT_REQUEST,
          payload,
     };
};

export const dataUploadSilentListComplete = (payload) => {
     return {
          type: dataUploadConstants.DATA_UPLOAD_LIST_SILENT_COMPLETE,
          payload,
     };
};

export const dataUploadAddRequest = (payload) => {
     return {
          type: dataUploadConstants.DATA_UPLOAD_ADD_REQUEST,
          payload,
     };
};

export const dataUploadAddComplete = (payload) => {
     return {
          type: dataUploadConstants.DATA_UPLOAD_ADD_COMPLETE,
          payload,
     };
};

export const dataUploadSummeryRequest = (payload) => {
     return {
          type: dataUploadConstants.DATA_UPLOAD_SUMMERY_REQUEST,
          payload,
     };
};

export const dataUploadSummeryComplete = (payload) => {
     return {
          type: dataUploadConstants.DATA_UPLOAD_SUMMERY_COMPLETE,
          payload,
     };
};

export const dataUploadDataProcessingRecodeRequest = (payload) => {
     return {
          type: dataUploadConstants.DATA_UPLOAD_DATA_PROCESSING_RECORD_REQUEST,
          payload,
     };
};

export const dataUploadDataProcessingRecodeComplete = (payload) => {
     return {
          type: dataUploadConstants.DATA_UPLOAD_DATA_PROCESSING_RECORD_COMPLETE,
          payload,
     };
};

export const dataUploadDownloadSummaryRequest = (payload) => {
     return {
          type: dataUploadConstants.DATA_UPLOAD_DATA_DOWNLOAD_SUMMARY_REQUEST,
          payload,
     };
};

export const dataUploadDownloadSummaryComplete = (payload) => {
     return {
          type: dataUploadConstants.DATA_UPLOAD_DATA_DOWNLOAD_SUMMARY_COMPLETE,
          payload,
     };
};

export const dataFileTypeListRequest = (payload) => {
     return {
          type: dataUploadConstants.DATA_FILE_TYPE_LIST_REQUEST,
          payload,
     };
};

export const dataFileTypeListCompelete = (payload) => {
     return {
          type: dataUploadConstants.DATA_FILE_TYPE_LIST_COMPLETE,
          payload,
     };
};

export const dataFileSchemaRequest = (payload) => {
     return {
          type: dataUploadConstants.DATA_FILE_SCHEMA_REQUEST,
          payload,
     };
};

export const dataFileSchemaCompelete = (payload) => {
     return {
          type: dataUploadConstants.DATA_FILE_SCHEMA_COMPLETE,
          payload,
     };
};

export const dataUploadRecordCountRequest = (payload) => {
     return {
          type: dataUploadConstants.DATA_UPLOAD_RECORD_COUNT_REQUEST,
          payload,
     };
};

export const dataUploadRecordCountComplete = (payload) => {
     return {
          type: dataUploadConstants.DATA_UPLOAD_RECORD_COUNT_COMPLETE,
          payload,
     };
};

export const downloadSchemaTempRequest = (payload) => {
     return {
          type: dataUploadConstants.DATA_UPLOAD_DOWNLOAD_SCHEMA_TEMP_REQUEST,
          payload,
     };
};

export const downloadSchemaTempComplete = (payload) => {
     return {
          type: dataUploadConstants.DATA_UPLOAD_DOWNLOAD_SCHEMA_TEMP_COMPLETE,
          payload,
     };
};

export const downloadActiveRecordsRequest = (payload) => {
     return {
          type: dataUploadConstants.DATA_UPLOAD_DOWNLOAD_ACTIVE_RECORDS_REQUEST,
          payload,
     };
};

export const downloadActiveRecordsComplete = (payload) => {
     return {
          type: dataUploadConstants.DATA_UPLOAD_DOWNLOAD_ACTIVE_RECORDS_COMPLETE,
          payload,
     };
};

export const downloadDeletedRecordsRequest = (payload) => {
     return {
          type: dataUploadConstants.DATA_UPLOAD_DOWNLOAD_DELETED_RECORDS_REQUEST,
          payload,
     };
};

export const downloadDeletedRecordsComplete = (payload) => {
     return {
          type: dataUploadConstants.DATA_UPLOAD_DOWNLOAD_DELETED_RECORDS_COMPLETE,
          payload,
     };
};

export const dataUploadListRefreshRealTime = (payload) => {
     return {
          type: dataUploadConstants.DATA_UPLOAD_LIST_REPRESH_REAL_TIME,
          payload,
     };
};
